module.exports = __webpack_public_path__ + "static/media/expand_more_double_arrow.2886f136.svg";